const expertiseGallery = new SimpleLightbox(
  '.expertise__gallery > ul > li > a',
  {}
);
